module.exports = __webpack_public_path__ + "media/images/ui__infoBoxSmall--dark-0b848df7c9dc14cc68015f64f20a74d8.png";